import { createSession } from '@getslot/api-client'
import { API_BASE } from '../config'
import { getInitData } from '../telegram/web-app'

/** Единственная сессия приложения; токены только в памяти вкладки. */
export const session = createSession({
  baseUrl: API_BASE,
  headers: { 'x-client': 'web' },
  getInitData,
})

export const api = session.api
